export default function Footer() {
  return (
    <footer className="border-t border-border/60 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <div>© {new Date().getFullYear()} <span className="gold-text font-semibold">Conecta Mais</span>. Todos os direitos reservados.</div>
        <div className="uppercase tracking-[0.25em] text-xs">participação · benefícios · oportunidades</div>
      </div>
    </footer>
  );
}
